export enum AnalyticsTypes {
  ARTICLE = 'article',
  EVENT = 'event',
  ARTICLE_SERIES = 'article-series',
  PDF = 'pdf',
  NOTIFICATION = 'notification',
  WIDGET = 'widget',
  DASHBOARD = 'dashboard',
  SEARCH = 'search',
  UPGRADE = 'upgrade',
  PING = 'ping',
  PWA_INSTALLATION = 'pwa_installation',
}
